import overrides from './overrides/overrides';
import typography from './typography/typography';
import palette from './palette/palette';
import shape from './shape/shape';

// const defaultTheme = createMuiTheme();

const theme = {
  overrides,
  typography,
  palette,
  shape,
};

export default theme;
